export enum DestinationTypeEnum {
    CITY = "CITY",
    AIRPORT = "AIRPORT"
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/destination-type.enum.ts